import { Edit, Delete, SupportAgentOutlined } from '@mui/icons-material';
import { Button, Skeleton, Tooltip } from '@mui/material';
import { GRID_DETAIL_PANEL_TOGGLE_COL_DEF } from '@mui/x-data-grid-pro';
import dayjs from 'dayjs';
import StatusCell from './StatusCell';

function contractItemsColumnArray(
  getDetailPanelContent,
  source,
  setEditingItemUuid,
  isPricingLoading,
  setIsSalesBOMItem,
  setIsSupportTicket,
) {
  return [
    {
      ...GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
      width: 40,
      renderCell: (params) => {
        const hasDetail = !!getDetailPanelContent({
          row: params.row,
        });
        if (!hasDetail) return null;
        return GRID_DETAIL_PANEL_TOGGLE_COL_DEF.renderCell(params);
      },
    },
    { field: 'title', headerName: 'Dienstleistung', flex: 1 },
    {
      field: 'pricingDate',
      headerName: 'Preisstellungsdatum',
      width: 160,
      type: 'date',
      valueFormatter: (value) =>
        value ? dayjs(value).format('DD.MM.YYYY') : null,
    },
    // {
    //   field: 'endDate',
    //   headerName: 'Enddatum',
    //   width: 90,
    //   valueFormatter: (value) =>
    //     value ? dayjs(value).format('DD.MM.YYYY') : null,
    // },
    {
      field: 'displayQuantity',
      headerName: 'Menge',
      width: 70,
      type: 'number',
    },
    {
      field: 'unitPrice',
      headerName: 'Preis/Einh €',
      width: 100,
      type: 'number',
      renderCell: (params) => {
        if (isPricingLoading && params.row.articleId) {
          return <Skeleton width="100%" />;
        }
        return params.value?.toLocaleString('de-DE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      },
    },
    {
      field: 'discountPercentage',
      headerName: 'Rabatt %',
      width: 80,
      type: 'number',
      renderCell: (params) => {
        if (isPricingLoading && params.row.articleId) {
          return <Skeleton width="100%" />;
        }
        return params.value === 0
          ? ''
          : params.value?.toLocaleString('de-DE', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 3,
            });
      },
    },
    {
      field: 'totalPrice',
      headerName: 'Gesamt €',
      width: 100,
      type: 'number',
      renderCell: (params) => {
        if (isPricingLoading && params.row.articleId) {
          return <Skeleton width="100%" />;
        }
        return params.value?.toLocaleString('de-DE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      },
    },
    {
      field: 'status',
      headerName: '',
      width: 54,
      align: 'center',
      renderCell: ({ value }) => <StatusCell value={value} />,
    },

    {
      field: 'edit',
      headerName: '',
      align: 'center',
      width: 54,
      renderCell: (params) => (
        <Tooltip title="Position bearbeiten">
          <span>
            <Button
              size="small"
              sx={{ minWidth: '32px' }}
              onClick={() => {
                setEditingItemUuid(params.row.uuid);
                setIsSalesBOMItem(false);
                setIsSupportTicket(false);
              }}
            >
              <Edit
                sx={{
                  fontSize: '18px',
                  color: 'text.secondary',
                }}
              />
            </Button>
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'support',
      headerName: '',
      width: 54,
      align: 'center',
      renderCell: (params) => (
        <Tooltip title={'Ticket für diese Position erstellen'}>
          <span>
            <Button
              size="small"
              sx={{ minWidth: '32px' }}
              onClick={() => {
                setEditingItemUuid(params.row.uuid);
                setIsSupportTicket(true);
              }}
              disabled={!source || source.length === 0}
            >
              <SupportAgentOutlined
                sx={{
                  color: 'text.secondary',
                }}
              />
            </Button>
          </span>
        </Tooltip>
      ),
    },
  ];
}
export default contractItemsColumnArray;
